var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpired = function SvgExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 190
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C7594",
    d: "M173.277 161.479s4.499-4.723 7.122-12.774c.089-.274.285-.5.545-.628.333-.164.595-.055.812.224.185.239.27.54.237.839-.22 1.734-1.492 9.628-6.967 15.86 0 0-2.314-.88-6.026-3.095l.942-2.187 3.335 1.76ZM103.588 185.872s6.523 2.005 15.33.761c.23-.032.463.01.666.12.482.265.506.62.271 1.027a1.16 1.16 0 0 1-.618.515c-1.686.57-9.75 3.011-18.172.785 0 0-.227-2.53.166-6.955l2.494-.125-.137 3.872Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C7594",
    d: "M71.677 103s30.99 5.773 51.406 16.495L171 158.05c-.564 2.41-1.654 3.841-2.917 4.949 0 0-31.406-10.773-52.447-30.773 0 0-40.261-8.609-54.636-18.918L71.677 103Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M114 132.062 121.876 122c.628 6.588-1.286 11.995-2.13 14a105.074 105.074 0 0 1-4.314-3.641s-.507-.102-1.432-.297Z",
    opacity: 0.074
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95AAC9",
    d: "M49 121.923s13.212 13.569 54.359 10.354c0 0-5.215 14.996-3.768 48.67 0 0 2.37 2.087 5.44.385L122 122.335S99.208 114.766 64.142 109L49 121.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF48",
    d: "M38.677 57s19.001 3.84 32.16 23.97c.742 1.135 4.78 10.326-.552 15.208-1.183 1.084-2.758 2.075-4.84 2.879C50.464 104.84 36 95.87 36 95.87l2.204-7.575s13.07 4.336 24.249-.053c0 0-14.014-8.15-23.776-31.242Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF48",
    d: "M26.909 64.156S15.697 93.626 47.619 125L73 102.833S52.394 80.717 38.483 57.058c0 0-7.214-1.183-11.574 7.098Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7C0",
    d: "M28.162 52s5.52 3.468 7.838 8.677c0 0-.187 6.392-5.479 3.631-1.189-3.814-3.428-6.746-6.521-8.96L28.162 52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M48.206 70.707a.367.367 0 0 1-.157-.511.406.406 0 0 1 .536-.15c4.374 2.276 8.807 7.475 10.398 12.468a.374.374 0 0 1-.264.47.4.4 0 0 1-.493-.251c-1.531-4.805-5.828-9.845-10.02-12.026Z",
    opacity: 0.089
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7C0",
    d: "M15.45 44s5.9 2.793 17.572.665c0 0 2.676 2.81-.825 7.712a6.855 6.855 0 0 1-3.145 2.435c-2.74 1.057-8.222 2.315-14.884-.674a.276.276 0 0 1-.099-.438c.85-1.018 3.51-4.726 1.777-9.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9AADB",
    d: "M23.959 56.255s-1.155 3.119-8.233 2.708a11.985 11.985 0 0 1-3.368-.675c-1.454-.512-3.477-1.406-4.347-2.603-2.002-2.752-.413-6.291-.413-6.291s2.605 2.17 2.79-1.195a6.483 6.483 0 0 0-.29-2.303c-.36-1.156-.98-3.49-.822-5.308a1.16 1.16 0 0 1 .93-1.016 1.205 1.205 0 0 1 1.284.549c.5.846 1.034 2.156 1.436 4.175 0 0-.559-6.119 2.15-6.296 0 0 5.401.512.002 16.553 0 0 3.177 1.222 8.922.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7D0B1",
    d: "M83.803 133 93 189h-3.897l-13.25-56h7.95Zm-34.656 0-13.25 56H32l9.197-56h7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEB8F",
    d: "M35.54 78.112s-.122 19.38 15.577 17.748c0 0 6.227-.922 3.808-11.468 0 0 1.712-3.09 3.253-1.736 8.872 7.8 5.252 25.6-8.805 27.146-11.473 1.263-21.515-3.389-23.333-17.693 0 0-1.201-15.575 9.5-13.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F85843",
    d: "M45.558 124.001h38.704c.211-.026.426-.039.644-.039 2.812 0 5.094 2.205 5.094 4.921 0 2.484-1.907 4.54-4.383 4.874l-.037.035-.321.001a5.296 5.296 0 0 1-.657.003L38.3 134s-15.641-27.927-19.231-42.82a2.591 2.591 0 0 1 1.476-2.964v-.003a2.526 2.526 0 0 1 3.156.974l21.857 34.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEBEF",
    d: "M113.5 0C129.781 0 143 13.443 143 30c0 16.557-13.219 30-29.5 30S84 46.557 84 30c0-16.557 13.219-30 29.5-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97B2B8",
    d: "M113.003 54.014c.81 0 1.466.669 1.466 1.493 0 .824-.657 1.493-1.466 1.493-.808 0-1.465-.669-1.465-1.493 0-.824.657-1.493 1.465-1.493ZM87.466 28.183c.809 0 1.465.668 1.465 1.492s-.656 1.493-1.465 1.493c-.81 0-1.466-.669-1.466-1.493 0-.824.657-1.492 1.466-1.492Zm51.068-.176c.81 0 1.466.67 1.466 1.493 0 .824-.657 1.493-1.466 1.493-.809 0-1.465-.67-1.465-1.493 0-.824.656-1.493 1.465-1.493ZM112.831 2c.809 0 1.466.669 1.466 1.493 0 .824-.657 1.493-1.466 1.493-.809 0-1.466-.669-1.466-1.493 0-.824.657-1.493 1.466-1.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E14",
    d: "M114 28c1.104 0 2 1.12 2 2.5s-.896 2.5-2 2.5-2-1.12-2-2.5.896-2.5 2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEB8F",
    d: "M110.312 33.756a.768.768 0 0 1-1.06.06.712.712 0 0 1-.062-1.027l11.498-12.545a.768.768 0 0 1 1.06-.06c.31.267.338.727.062 1.027l-11.498 12.545Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEB8F",
    d: "M111.275 52.393c-.063.401-.398.668-.747.595-.35-.073-.581-.458-.518-.86l3.715-23.52c.063-.402.398-.669.747-.596.35.073.581.458.518.86l-3.715 23.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6554",
    d: "M98.11 11.79a.497.497 0 0 1 .045-.673.433.433 0 0 1 .635.047l18.1 22.046c.163.199.143.5-.045.673a.433.433 0 0 1-.635-.047L98.11 11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.876 37s1.462 5.512-5.64 17H26l6.066-17h.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0EC8D6",
    d: "M7.08 33 33 37.967 26.063 56 0 51.057zM35 36.998 8.57 32H7l25.988 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#049AC6",
    d: "m7 32 26 4.632V37L7 32.363zM33 38h2v-1h-2z"
  }))));
};
export default SvgExpired;